import { render, staticRenderFns } from "./ProcessingOfRequests.vue?vue&type=template&id=a12ab82e"
import script from "./ProcessingOfRequests.vue?vue&type=script&lang=ts"
export * from "./ProcessingOfRequests.vue?vue&type=script&lang=ts"
import style0 from "./ProcessingOfRequests.vue?vue&type=style&index=0&id=a12ab82e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports